import { BaseFlexibleReportRequest } from '@features/flexible-reports';
import { Chip, ChipProps } from '@mui/material';
import { capitalize } from '@utils/strings';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

const statusColorSchemes = {
  draft: {
    text: unifiedPlatformColorPalette.lightTextSecondary,
    background: unifiedPlatformColorPalette.lightGrey300,
  },
  processing: {
    text: unifiedPlatformColorPalette.lightTextSecondary,
    background: unifiedPlatformColorPalette.lightSecondaryLight,
  },
  ready: {
    text: unifiedPlatformColorPalette.lightPrimary900,
    background: unifiedPlatformColorPalette.lightPrimaryShades30p,
  },
  failed: {
    text: unifiedPlatformColorPalette.lightErrorDark,
    background: unifiedPlatformColorPalette.lightErrorShades30p,
  },
} as const satisfies Record<
  BaseFlexibleReportRequest['status'],
  { text: string; background: string }
>;

type StatusChipProps = {
  status: BaseFlexibleReportRequest['status'];
  sx?: ChipProps['sx'];
};

export const StatusChip = (props: StatusChipProps) => {
  return (
    <Chip
      size="small"
      sx={{
        color: statusColorSchemes[props.status].text,
        backgroundColor: statusColorSchemes[props.status].background,
        ...props.sx,
      }}
      label={capitalize(props.status)}
    />
  );
};
